module.exports = __webpack_public_path__ + "img/play_2.bf3f9261.png";